import { useNavigate, useSearchParams } from 'react-router-dom'
import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
  Button,
  Alert
} from '@mui/material'
import { CheckCircle } from '@mui/icons-material'

function BillingSuccessPage() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const sessionId = searchParams.get('session_id')

  if (!sessionId) {
    return (
      <Container maxWidth="sm" sx={{ py: 8 }}>
        <Alert severity="error" sx={{ mb: 3 }}>
          Invalid payment session
        </Alert>
        <Box sx={{ textAlign: 'center' }}>
          <Button
            variant="contained"
            onClick={() => navigate('/billing/upgrade')}
          >
            Return to Upgrade Page
          </Button>
        </Box>
      </Container>
    )
  }

  return (
    <Container maxWidth="sm" sx={{ py: 8 }}>
      <Card elevation={3}>
        <CardContent sx={{ p: 4, textAlign: 'center' }}>
          <CheckCircle
            sx={{
              fontSize: 80,
              color: 'success.main',
              mb: 2
            }}
          />
          <Typography variant="h4" component="h1" gutterBottom fontWeight="bold">
            Payment Successful!
          </Typography>
          <Typography variant="body1" color="text.secondary" paragraph>
            Thank you for subscribing to Helpdesk Pro. Your payment has been processed successfully.
          </Typography>
          <Typography variant="body2" color="text.secondary" paragraph>
            Your subscription is now active and you have full access to all features.
            It may take a few moments for your account to be fully updated.
          </Typography>

          <Box sx={{ mt: 4 }}>
            <Button
              variant="contained"
              size="large"
              onClick={() => navigate('/admin/billing')}
              sx={{ mb: 2 }}
            >
              View Billing Dashboard
            </Button>
            <br />
            <Button
              variant="text"
              onClick={() => navigate('/admin/dashboard')}
            >
              Go to Dashboard
            </Button>
          </Box>
        </CardContent>
      </Card>

      <Alert severity="info" sx={{ mt: 3 }}>
        You will receive a confirmation email shortly with your subscription details.
      </Alert>
    </Container>
  )
}

export default BillingSuccessPage
